import React, { useEffect, useContext, useState } from "react";
// import dynamic from 'next/dynamic';
import Sticky from "react-stickynode";
import Header from "./Header/Header";
import Footer from "./Footer/Footer";
import { AppContext } from "../../contexts/app/app.context";
import { LayoutWrapper } from "./Layout.style";
import { isCategoryPage } from "./is-home-page";
import {useLocation, useHistory} from "react-router-dom";
import MobileHeader from "./Header/MobileHeader";
import Sidebar from "../../components/Sidebar";
import SupplierSidebar from "../../components/SupplierSidebar";
import SupplierLoginScreen from "../../pages/supplier/supplier-login";

import AdminHeader from "../../components/AdminHeader";
import SupplierHeader from "../../components/SupplierHeader";
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { makeStyles } from "@material-ui/core";
import { useMaintenanceMode } from "../../components/MaintenanceMode/MaintenanceModeProvider";
import MaintenanceMode from "../../components/MaintenanceMode/MaintenanceMode";
import { logoutuser } from "../../helper/constant";
import * as Constant from '../../constants/Constant';
import axios from 'axios';
import DownloadAppPopup from "../../components/DownloadAppPopup/DownloadAppPopupV2";
let admin = localStorage.getItem("admin");
let supplier = localStorage.getItem("supplier");

const useStyles = makeStyles({
	sidebar: {
		width: "270px",
		flex: "0 0 270px",
		"@media(max-width: 576px)": {
			width: "100%",
			flex: 1,
		},
	},
	content: {
		width: "calc(100% - 270px)",
		flex: "1 1 calc(100% - 270px)",
		paddingInline: 15,
		"@media(max-width: 576px)": {
			width: "100%",
			flex: 1,
		},
	},
});

const AppLayout = ({
  className,
  children,
  deviceType: { mobile, tablet, desktop },
  showNotification,
  token,
}) => {
  const { state } = useContext(AppContext);
  const { isMaintenanceMode } = useMaintenanceMode();
  const isSticky = state.isSticky;

  const classes = useStyles();

  const { pathname } = useLocation();
	const history = useHistory();
  const isHomePage = isCategoryPage(pathname);
  const verifyTokenExpired = async () => {
    let user = localStorage.getItem("user");
      let admin = localStorage.getItem("admin");
      let supplier = localStorage.getItem("supplier");
      let parsedUser = JSON.parse(user);
      let parsedAdmin = JSON.parse(admin);
      let parsedSupplier = JSON.parse(supplier);
      const token = localStorage.getItem("token");
      if(parsedUser || parsedAdmin || parsedSupplier || token){
        new Promise(async (resolve, reject) => {
          const CancelToken = axios.CancelToken;
          const source = CancelToken.source();
      
          try {
            let endPoint = '';
            if(admin){
              endPoint = 'v1/admin/get/all/deliveryrule';
            }else{
              endPoint = 'api/notification/getCountUnreadNotifications';
            }
            const api = Constant.baseUrl+endPoint
            const itemResp = await axios.get(api, { cancelToken: source.token, headers: { Authorization: token } });
      
            console.log("itemResp",itemResp);
            resolve(itemResp);
            source.cancel('Operation canceled by the user.'); // cancel the request (the message parameter is optional)
          }
          catch(e) {
            if(e.response.status === 401){
              logoutuser();
            }
            resolve(e.response);
          }
        })
      }
  }

  useEffect(() => {
    verifyTokenExpired();
  }, [isMaintenanceMode])

  if(admin == null && supplier == null)
  {
    if(isMaintenanceMode === true){
      if(window.location.pathname !== "/manager/login"){
        return <MaintenanceMode />
      }else{
        return (
          <LayoutWrapper className={`layoutWrapper ${className}`}>
            {(mobile || tablet) && (
              <Sticky enabled={isSticky} innerZ={1001}>
                <MobileHeader
                  className={`${isSticky ? "sticky" : "unSticky"} ${
                    isHomePage ? "home" : ""
                  }`}
                  pathname={pathname}
                />
              </Sticky>
            )}
            {desktop && (
              <Sticky enabled={isSticky} innerZ={1001}>
                <MobileHeader
                  id="mheader"
                  className={`${isSticky ? "sticky" : "unSticky"} ${
                    isHomePage ? "home" : ""
                  } desktop`}
                  pathname={pathname}
                />
                <Header
                  id="dheader"
                  className={`${isSticky && isHomePage ? "sticky" : "unSticky"} ${
                    isHomePage ? "home" : ""
                  }`}
                  token={token}
                  pathname={pathname}
                  showNotification={showNotification}
                />
              </Sticky>
            )}
            <SupplierLoginScreen />
            <Footer id={"footer"} />
          </LayoutWrapper>
        );
      }
    }else{
      return (
        <LayoutWrapper className={`layoutWrapper ${className}`}>
           <DownloadAppPopup deviceType={{mobile:mobile, tablet:tablet, desktop:desktop}}></DownloadAppPopup>
          {(mobile || tablet) && (
            <Sticky enabled={isSticky} innerZ={1001}>
              <MobileHeader
                className={`${isSticky ? "sticky" : "unSticky"} ${
                  isHomePage ? "home" : ""
                }`}
                pathname={pathname}
              />
            </Sticky>
          )}
          {desktop && (
            <Sticky enabled={isSticky} innerZ={1001}>
              <MobileHeader
                id="mheader"
                className={`${isSticky ? "sticky" : "unSticky"} ${
                  isHomePage ? "home" : ""
                } desktop`}
                pathname={pathname}
              />
              <Header
                id="dheader"
                className={`${isSticky && isHomePage ? "sticky" : "unSticky"} ${
                  isHomePage ? "home" : ""
                }`}
                token={token}
                pathname={pathname}
                showNotification={showNotification}
              />
            </Sticky>
          )}
          {children}
          <Footer id={"footer"} />
        </LayoutWrapper>
      );
    }
  } else if(admin) { 
    return (
      <LayoutWrapper className={`layoutWrapper container-fluid ${className}`}>
        <Row>
          <AdminHeader />
        </Row>
        <Row>
          {/* <Col sm={2} className="pl-0 pr-0">
            <Sidebar />
          </Col>
          <Col sm={10}>
            {children}
          </Col> */}
          <div className={classes.sidebar}>
            <Sidebar />
          </div>
          <div className={classes.content}>
            {children}
          </div>
        </Row>
      </LayoutWrapper>
    );
  }else {
    if(isMaintenanceMode === true){
      if(window.location.pathname !== "/manager/login"){
        return <MaintenanceMode />
      }else{
        return (
          <LayoutWrapper className={`layoutWrapper container-fluid ${className}`}>
            <Row>
              <SupplierHeader />
            </Row>
            <Row>
              <Col sm={2} className="pl-0 pr-0">
                <SupplierSidebar />
              </Col>
              <Col sm={10}>
              <SupplierLoginScreen />
              </Col>
            </Row>
          </LayoutWrapper>
        );
      }
    }else{
      return (
        <LayoutWrapper className={`layoutWrapper container-fluid ${className}`}>
          <Row>
            <SupplierHeader />
          </Row>
          <Row>
            <Col sm={2} className="pl-0 pr-0">
              <SupplierSidebar />
            </Col>
            <Col sm={10}>
              {children}
            </Col>
          </Row>
        </LayoutWrapper>
      );
    }
  } 
};

export default AppLayout;
